export default {
  install(Vue, options) {
    Vue.prototype.$hasPerm = function (perm) {
      return (this.$store.state.user.data.permissions || []).includes(perm)
    }
    Vue.prototype.$perms = {
      admin: {
        ORGANIZATIONS: 'organizations',
        ORGANIZATIONS_APPROVES: 'organizations.approves',
        ORGANIZATIONS_REACTIONS: 'organizations.reactions',
        STARTUPS: 'startups',
        MAILS: 'mails',
        CHATS: 'chats',
        MARKETPLACE: 'marketplace',
        USERS: 'users',
        USERS_ACTIVITY: 'users.activity',
        USERS_MANAGE_PERMISSIONS: 'users.manage_permissions',
        STATS: 'stats',
      },
    }
  },
}
